import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert, Button, Table, FileDrop,
} from '@canaveral/components';
import { MAX_FILE_SIZE_MB, ACCEPTED_FILE_TYPES } from './constants';
import styles from './FileList.scss';

const propTypes = {
  destroy: PropTypes.func.isRequired,
  destroying: PropTypes.bool.isRequired,
  error: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  load: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onUpload: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onAttach: PropTypes.func.isRequired,
};

const defaultProps = {
  error: undefined,
  files: [],
};

class FileList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { error: null };
  }

  componentDidMount() {
    const { load } = this.props;

    load();
  }

  onUpload = (e) => {
    const { files } = e.target;
    const { onUpload } = this.props;

    if (files.length !== 1) {
      this.setState({ error: 'Please select only one file.' });
      return;
    }

    const file = files[0];

    if (file.size / 1000000 > MAX_FILE_SIZE_MB) {
      this.setState({ error: `${file.name} exceeds the maximum allowed file size.` });
      return;
    }

    this.onDismiss();
    onUpload(file);
  }

  onAttach = file => () => {
    const { onAttach } = this.props;

    this.onDismiss();
    onAttach(file);
  }

  onEdit = file => () => {
    const { onEdit } = this.props;

    this.onDismiss();
    onEdit(file);
  }

  onEdit = file => () => {
    const { onEdit } = this.props;

    this.onDismiss();
    onEdit(file);
  }

  onDelete = file => () => {
    const { destroy } = this.props;

    destroy(file.id);
  }

  onDismiss = () => this.setState({
    error: null,
  })

  render() {
    const { destroying, files, loading } = this.props;
    const error = this.state.error || this.props.error;

    if (loading) {
      return 'Loading...';
    }

    return (
      <React.Fragment>
        {error && (
          <Alert context="danger">
            {error}
          </Alert>
        )}
        <FileDrop
          name="files"
          onChange={this.onUpload}
          accept={ACCEPTED_FILE_TYPES}
          maxFileSize={MAX_FILE_SIZE_MB}
        />
        <div className={styles.info}>
          Max file size: {MAX_FILE_SIZE_MB} MB
        </div>
        <div className={styles.info}>
          Accepted file types: PDFs, images, word documents, spreadsheets, and CSVs
        </div>
        <Table striped>
          <thead>
            <tr>
              <th>Title</th>
              <th>File</th>
              <th className={styles.controls} />
            </tr>
          </thead>
          <tbody>
            {files.map(file => (
              <tr key={file.id}>
                <td>{file.name}</td>
                <td>
                  <a href={file.path} target="_blank" rel="noopener noreferrer">
                    {file.filename}
                  </a>
                </td>
                <td>
                  <Button
                    size="sm"
                    label="Attach"
                    icon="paperclip"
                    context="positive"
                    onClick={this.onAttach(file)}
                  />
                  <Button
                    size="sm"
                    icon="edit2"
                    label="Edit"
                    context="neutral"
                    onClick={this.onEdit(file)}
                  />
                  <Button
                    size="sm"
                    icon="delete"
                    label="Delete"
                    context="negative"
                    disabled={destroying}
                    onClick={this.onDelete(file)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

FileList.propTypes = propTypes;
FileList.defaultProps = defaultProps;

export default FileList;
